/**
 * Answer Validation Utilities
 *
 * Handles normalization and validation of player answers against
 * correct answers (including alternates).
 */

/**
 * Normalize an answer for comparison
 *
 * Rules:
 * - Convert to uppercase
 * - Trim whitespace
 * - Collapse multiple spaces to single space
 *
 * @param answer - Raw answer string
 * @returns Normalized answer
 */
export function normalizeAnswer(answer: string): string {
  return answer
    .trim()
    .toUpperCase()
    .replace(/\s+/g, ' ');
}

/**
 * Check if a guess matches any of the correct answers
 *
 * @param guess - Player's guess
 * @param correctAnswers - Array of correct answers (primary + alternates)
 * @returns True if guess matches any correct answer
 */
export function isCorrectAnswer(
  guess: string,
  correctAnswers: string[]
): boolean {
  const normalizedGuess = normalizeAnswer(guess);

  console.log('--- isCorrectAnswer ---');
  console.log('Raw guess:', guess);
  console.log('Normalized guess:', normalizedGuess);
  console.log('Correct answers (raw):', correctAnswers);
  console.log('Correct answers (normalized):', correctAnswers.map(a => normalizeAnswer(a)));

  const result = correctAnswers.some(answer => {
    const normalizedAnswer = normalizeAnswer(answer);
    const matches = normalizedAnswer === normalizedGuess;
    console.log(`Comparing "${normalizedAnswer}" === "${normalizedGuess}": ${matches}`);
    return matches;
  });

  console.log('Final result:', result);
  console.log('----------------------');

  return result;
}

/**
 * Validate input text
 *
 * @param text - Input text
 * @param maxLength - Maximum allowed length
 * @returns True if valid
 */
export function isValidInput(text: string, maxLength: number = 80): boolean {
  if (text.length === 0) return false;
  if (text.length > maxLength) return false;

  // Allow alphanumeric, space, hyphen, apostrophe
  const validPattern = /^[a-zA-Z0-9\s\-']+$/;
  return validPattern.test(text);
}
